/**
 * http://usejsdoc.org/
 */
import { create } from 'apisauce';
import authStore from '../stores/auth-store';
import urlgetter from './getMainUrl';

const api = create({
	baseURL: urlgetter.getMainApiUrl()
});

const func = {};

func.loadAllJumpers = () => {
	//console.log('in loadAllJumpers');
  return api.get('/jumpers');
}
func.UpdateJumper = (id, jumperBody) => {
	// return api.put('/jumpers/'+memberNumber+'/addRating',ratingBody);
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('jumpers/local/' + id, jumperBody);
}

func.loadAllJumpersNew = () => {
	//console.log('in loadAllJumpers');
  return api.get('/getLocalJumper');
}

func.initializeLocalJumpers = () => {
	//console.log('in initializeLocalJumpers');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
    return api.get('/jumpers/initLocal');
}

func.loadTodayTandemStudents = () => {
	// console.log('in initializeLocalJumpers');
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	let sDate = new Date();
	sDate = sDate.setHours(0, 0, 0, 0);
	let startDate = new Date(sDate);
	startDate = startDate.toISOString('yyyy-mm-ddThh:mm:ss.000Z');

	let eDate = new Date();
	eDate = eDate.setHours(23, 59, 59, 999);
	let endDate = new Date(eDate);
	endDate = endDate.toISOString('yyyy-mm-ddThh:mm:ss.000Z');

	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/jumpers/loadTodayTandemStudents?start=' + startDate + '&end=' + endDate);
}

func.loadAllJumpers = () =>{
	//console.log('in loadAllJumpers');
    var token = authStore.getAuthToken();
    if(token == '')
    {
       token = localStorage.getItem("Auth-token");
    }
    //console.log(token);
    api.setHeader('Authorization', 'Bearer ' + token)
    return api.get('/jumpers');
}

// func.getDailyActivity = (jumperId) => {
// 	//console.log('in get Daily Activity');
// 	return api.get('/reports/getDailyActivities/' + jumperId);
// }

func.getJumpWithSuggestions = (payload) => {
	//console.log('in get Daily Activity');
	return api.post('/reports/getJumpWithSuggestions/', payload);
}

func.getJumpWithSuggestions = (payload) => {
	//console.log('in get Daily Activity');
	return api.post('/reports/getJumpWithSuggestions/', payload);
}

func.createJumper = (jumperBody) => {
	//console.log("in Create Jumper Activity");
	return api.post('/jumpers',jumperBody);
}

func.addMediaUrl = (id, body) => {
	//alert('in create Jumper api');
	// console.log("In Transfer Credit");
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('jumpers/addMediaUrl/' + id, body);
}

func.sendTandemMediaEmail = (body) => {
	console.log('sendTandemMediaEmail');
	console.log(body);
	//alert('in create Jumper api');
	// console.log("In Transfer Credit");
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.post('reports/sendTandemMediaEmail', body);
}

func.TransferCredit = (creditBody) => {
	//alert('in create Jumper api');
	// console.log("In Transfer Credit");
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.post('jumpers/local/transferCredit', creditBody);
}
func.getAllDailyActivity = (jumperId) => {
	// console.log('in get Daily Activity');
	return api.get('/reports/getAllDailyActivities/');
}
func.checkin = (id, tiaspi, video) => {
	// console.log('in load global jumper options');
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
  var querystring='';

  if(tiaspi){
    querystring = '?tiaspi=true';
    if(video){
      querystring += "&video=true"
    }
  }
  else if(video){
    querystring += '?video=true'
  }
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/jumpers/checkin/' + id + querystring);
}

func.checkout = (id) => {
	// console.log('in load global jumper options');
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('/jumpers/checkout/' + id);
}

func.submitPackJob = (payload) => {
	// console.log('in load global jumper options');
  /*
    {
      packerId: id,
      rigId: id,
      type : String
    }
  */
	var token = authStore.getAuthToken();

	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token);

	return api.post('/jumpers/submitPackJob/', payload);
}

func.removePackJob = (payload) => {
	// console.log('in load global jumper options');
  /*
    {
      packerId: id,
      type: String
    }
  */
	var token = authStore.getAuthToken();

	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token);

	return api.post('/jumpers/removePackJob/', payload);
}

func.getStudentLogs = (id) => {
	//alert('in create Jumper api');
	// console.log("In Transfer Credit");
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.get('jumpers/logs/'+id);
}

func.submitStudentLog = (id, payload) => {
	//alert('in create Jumper api');
	// console.log("In Transfer Credit");
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.post('jumpers/logs/'+id, payload)
}

func.createRating = (ratingBody,number) => {
	//console.log("JumperID"+ number);
	//console.log(JSON.stringify(ratingBody));
	return api.post('/jumpers/'+number+'/addRating',ratingBody);
}

func.getJumperDetails = (payload) =>{
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	// console.log(token,"token tokentoken")
	api.setHeader('Authorization', 'Bearer ' + token)

	return api.get('/reports/getDailyActivities/' + payload);
}

func.UpdateJumper = (id, jumperBody) => {
	// return api.put('/jumpers/'+memberNumber+'/addRating',ratingBody);
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	// console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.put('jumpers/local/' + id, jumperBody);
}


func.RemoveCardOnFile = (jumperid,id) => {
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.delete('jumpers/' + jumperid + '/cardOnFile/'+id);
}

func.RemoveAccountOnFile = (jumperid,id) => {
	var token = authStore.getAuthToken();
	if (token == '') {
		token = localStorage.getItem("Auth-token");
	}
	api.setHeader('Authorization', 'Bearer ' + token)
	return api.delete('jumpers/' + jumperid + '/AccountOnFile/'+id);
}


export default func;
